import * as React from 'react';

const MobileMenuButton = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
        <rect width={31} height={31} x={0.5} y={0.5} fill="#fff" rx={15.5} />
        <path fill="currentColor" d="m12.75 20.885 4.58-4.59-4.58-4.59 1.41-1.41 6 6-6 6z" />
        <rect width={31} height={31} x={0.5} y={0.5} stroke="#A8A8A8" rx={15.5} />
    </svg>
);
export default MobileMenuButton;
